import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CollaboratorInvitation } from "@models/collaborator";
import { InvitationStatusEnum } from "@models/invitation";
import { CollaboratorRoleEnumPipe } from "@shared/pipes/collaborator-role-enum.pipe";
import { InvitationStatusEnumPipe } from "@shared/pipes/invitation-status-enum.pipe";
import { environment } from "../../../../../../environments/environment";
import { ButtonComponent } from "../../../../../../shared/components/button/button.component";

@Component({
    selector: "app-collaborator-invitation-card",
    imports: [
        CommonModule,
        ButtonComponent,
        InvitationStatusEnumPipe,
        CollaboratorRoleEnumPipe,
        RouterModule,
    ],
    templateUrl: "./collaborator-invitation-card.component.html",
    styleUrl: "./collaborator-invitation-card.component.scss"
})
export class CollaboratorInvitationCardComponent {
  @Input({ required: true }) invitation!: CollaboratorInvitation;
  @Input() isLoading = false;

  @Output()
  acceptClick = new EventEmitter<CollaboratorInvitation>();

  invitationStatusEnum = InvitationStatusEnum;

  handleAcceptClick() {
    this.acceptClick.emit(this.invitation);
  }

  loadEventImage(event_thumb: string) {
    return `${environment.BLOB_URL}/${event_thumb}`;
  }
}
